import axios from "axios";

const consultCEP = async (cep: string) => {
    if (!cep || cep.length < 8) return { erro: true }
    try {
        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
        return response.data
    } catch (error) {
        console.error('Erro ao consultar CEP:', error);
        return { erro: true }
    }
}
const Correios = {
    consultCEP
}
export default Correios;